














import { Vue, Component } from 'vue-property-decorator';
import VoteList from './components/VoteList.vue';
import * as config from './config';
import { getTypes } from './api/index';

@Component({
  components: {
    VoteList,
  },
})
export default class List extends Vue {
  option = config.OPTHINES;
  ListTabs = {};
  activeClass: number = 0;
  listType: number = 0;
  async created() {
    const res = await getTypes();
    this.ListTabs = Object.values(res.data).reverse();
    // this.ListTabs = res.data;
  }
  public changeListTabs(index: number) {
    this.activeClass = index;
    if (index === 0) {
      this.listType = 3;
    } else if (index === 1) {
      this.listType = 2;
    } else {
      this.listType = 1;
    }
  }
}
